import React, {useEffect, useState} from 'react'
import {Row, Col} from 'react-bootstrap'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {defaultSalesChannelInfo} from '../InterfaceSalesChannelModal'
import {UPDATE_SALES_CHANNEL} from '../../../../../utils/GraphQLAPI'
import {useMutation} from '@apollo/client'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import Settings from '../steps/Settings'
interface Props {
  salesData: any
}

const SalesChannelInfo = ({salesData}: Props) => {
  const MySwal = withReactContent(Swal)
  const [disabled, setDisabled] = useState<boolean>(true)
  const [btnShow, setBtnShow] = useState<boolean>(false)

  const handleEdit = () => {
    setDisabled(false)
    setBtnShow(true)
  }

  useEffect(() => {
    const editSalesChannelEnrollment = {
      salesChannelName: salesData.salesChannelName,
      salesChannelAdminFirstName: salesData.salesChannelAdminFirstName,
      salesChannelAdminLastName: salesData.salesChannelAdminLastName,
      salesChannelAdminEmail: salesData.salesChannelAdminEmail,
      productIds: salesData.products,
      ivr: salesData.enableIvr,
      liveAgent: salesData.enableLiveAgent,
      textTpv: salesData.enableTextTpv,
      smsD2D: salesData.enableSmsDocumentVerification,
      emailD2D: salesData.enableEmailDocumentVerification,
      outboundLiveAgent: salesData.enableOutBoundLiveAgent,
    }
    formik.setValues({...editSalesChannelEnrollment})
  }, [salesData])

  const salesChannelInfoSchema = Yup.object().shape({
    salesChannelName: Yup.string()
      .required('Channel name is Required')
      .trim()
      .matches(/^[A-Za-z0-9 ]+$/, 'Special characters not allowed')
      .matches(/[^0-9]/, 'Numbers are not allowed')
      .min(3, "Channel name shouldn't be less than 3 characters")
      .max(40, 'Channel name should not exceed 40 characters'),
    salesChannelAdminFirstName: Yup.string()
      .required('Admin First name is Required')
      .trim()
      .matches(/^[A-Za-z ]+$/, 'Name should not have numbers')
      .min(3, "Admin first name shouldn't be less than 3 characters")
      .max(40, 'Admin first name should not exceed 40 characters'),
    salesChannelAdminLastName: Yup.string()
      .required('Admin Last name is Required')
      .trim()
      .matches(/^[A-Za-z ]+$/, 'Name should not have numbers')
      .min(3, "Admin last name shouldn't be less than 3 characters")
      .max(40, 'Admin last name should not exceed 40 characters'),
    salesChannelAdminEmail: Yup.string()
      .required('Email id is Required')
      .trim()
      .email('Enter a valid email id'),
  })

  const salesId = localStorage.getItem('salesEditId')

  const [updateSalesChannel] = useMutation(UPDATE_SALES_CHANNEL, {
    onCompleted: (data) => {
      const options: any = {
        customClass: {
          popup: 'swal2-border-radius',
        },
        title: 'Sales Channel updated successfully',
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      }
      MySwal.fire(options)
      setDisabled(true)
      setBtnShow(false)
    },
    onError: (e) => {
      MySwal.fire({
        icon: 'error',
        title: e.message,
      })
      setDisabled(true)
      setBtnShow(false)
    },
  })

  const formik = useFormik({
    initialValues: defaultSalesChannelInfo,
    validationSchema: salesChannelInfoSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      updateSalesChannel({
        variables: {
          updateSalesChannelInput: {
            id: salesId,
            salesAdminFirstName: values.salesChannelAdminFirstName,
            salesAdminLastName: values.salesChannelAdminLastName,
            salesChannelName: values.salesChannelName,
            salesAdminEmailId: values.salesChannelAdminEmail,
            enableIvr: values.ivr,
            enableLiveAgent: values.liveAgent,
            enableTextTpv: values.textTpv,
            enableSmsDocumentVerification: values.smsD2D,
            enableEmailDocumentVerification: values.emailD2D,
            enableOutBoundLiveAgent: values.outboundLiveAgent,
          },
        },
      })
    },
  })
  console.log('fomrik', formik.values, 'discard', disabled)
  const handleDiscard = () => {
    console.log('SalesData', salesData)
    const editSalesChannelEnrollmentt = {
      ...formik.values,
      salesChannelName: salesData.salesChannelName,
      salesChannelAdminFirstName: salesData.salesChannelAdminFirstName,
      salesChannelAdminLastName: salesData.salesChannelAdminLastName,
      salesChannelAdminEmail: salesData.salesChannelAdminEmail,
      ivr: salesData.enableIvr,
      liveAgent: salesData.enableLiveAgent,
      textTpv: salesData.enableTextTpv,
      smsD2D: salesData.enableSmsDocumentVerification,
      emailD2D: salesData.enableEmailDocumentVerification,
    }
    formik.setValues({...editSalesChannelEnrollmentt})
    setDisabled(true)
    setBtnShow(false)
    formik.setErrors({})
  }

  return (
    <div>
      <div className='current p-4' data-kt-stepper-element='content'>
        {/* Modal Header Start */}
        <div className='row mb-5'>
          <div className='col-6'>
            <label className='d-flex align-items-center fs-4 fw-bold mb-4 lh-1'>
              <span className='fs-2 fw-bolder text-gray-900'>Sales Channel</span>
            </label>
          </div>
          <div className='col-6 text-end'>
            <button
              type='button'
              className={`btn btn-primary text-white btn-active-color-primary btn-md me-1 ${
                btnShow ? 'd-none' : null
              }`}
              onClick={() => handleEdit()}
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
              style={{
                position: 'absolute',
                right: '20px',
                top: '48px',
                height: '35px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              Edit
            </button>
          </div>
        </div>
        {/* Modal Header End */}
        <Row
          className='d-flex align-items-end mt-5 no-gutters noPadding'
          style={{marginBottom: '15px'}}
        >
          <Col sm={4} md={4} className='mr-0 ml-0 pb-5'>
            <label className='d-flex align-items-center mb-2'>
              <span className='fs-6 fw-semibold lh-23px'>
                Sales Channel Name <span className='h5 text-danger'>*</span>
              </span>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              id='salesChannelName'
              placeholder='Enter Sales Channel Name'
              maxLength={51}
              {...formik.getFieldProps('salesChannelName')}
              onChange={(e) => {
                formik.setFieldValue('salesChannelName', e.target.value.replace(/[0-9]/g, ''))
              }}
              disabled={disabled}
            />
            {formik.errors.salesChannelName && formik.touched.salesChannelName && (
              <div className='fv-plugins-message-container' style={{width: '29%'}}>
                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                  {formik.errors.salesChannelName}
                </div>
              </div>
            )}
          </Col>
          <Col sm={4} md={4} className='mr-0 ml-0 pb-5'>
            <label className='d-flex align-items-center mb-2'>
              <span className='fs-6 fw-semibold lh-23px'>
                Sales Channel Admin Email ID <span className='h5 text-danger'>*</span>
              </span>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              id='salesChannelAdminEmail'
              placeholder='Enter email id'
              maxLength={51}
              disabled={disabled}
              {...formik.getFieldProps('salesChannelAdminEmail')}
            />
            {formik.errors.salesChannelAdminEmail && formik.touched.salesChannelAdminEmail && (
              <div className='fv-plugins-message-container' style={{width: '29%'}}>
                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                  {formik.errors.salesChannelAdminEmail}
                </div>
              </div>
            )}
          </Col>
          <Col sm={4} md={4} className='mr-0 ml-0 pb-5'>
            <label className='d-flex align-items-center mb-2'>
              <span className='fs-6 fw-semibold lh-23px'>
                Sales Channel Admin First Name <span className='h5 text-danger'>*</span>
              </span>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              id='salesChannelAdminFirstName'
              placeholder='Enter admin first name'
              maxLength={51}
              disabled={disabled}
              {...formik.getFieldProps('salesChannelAdminFirstName')}
            />
            {formik.errors.salesChannelAdminFirstName && formik.touched.salesChannelAdminFirstName && (
              <div className='fv-plugins-message-container' style={{width: '29%'}}>
                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                  {formik.errors.salesChannelAdminFirstName}
                </div>
              </div>
            )}
          </Col>
        </Row>
        <Row
          className='d-flex align-items-end mt-5 no-gutters noPadding'
          style={{marginBottom: '15px'}}
        >
          <Col sm={4} md={4} className='mr-0 ml-0 pb-5'>
            <label className='d-flex align-items-center mb-2'>
              <span className='fs-6 fw-semibold lh-23px'>
                Sales Channel Admin Last Name <span className='h5 text-danger'>*</span>
              </span>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              id='salesChannelAdminLastName'
              placeholder='Enter admin last name'
              maxLength={51}
              disabled={disabled}
              {...formik.getFieldProps('salesChannelAdminLastName')}
            />
            {formik.errors.salesChannelAdminLastName && formik.touched.salesChannelAdminLastName && (
              <div className='fv-plugins-message-container' style={{width: '29%'}}>
                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                  {formik.errors.salesChannelAdminLastName}
                </div>
              </div>
            )}
          </Col>
        </Row>
        <Settings formik={formik} isEdit={true} editDisabled={disabled} />
        <div className='d-flex flex-stack pt-5'>
          <div className='me-2'></div>
          <div>
            <button
              className={`btn btn-lg btn-light ${btnShow ? null : 'd-none'}`}
              onClick={() => handleDiscard()}
            >
              Discard
            </button>
            <button
              onClick={() => formik.submitForm()}
              className={`btn btn-lg btn-primary ms-4 ${btnShow ? null : 'd-none'}`}
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SalesChannelInfo
